// @flow

import { getApiBaseUrl, basicGet } from '../utils/api'
import type { APIError } from '../types'
import type { Action } from '../types/actions/manifest'
import { getErrorAction } from '../utils/actions'

export const GET_MANIFEST_SUCCESS = 'GET_MANIFEST_SUCCESS'
export const GET_MANIFEST_FAILURE = 'GET_MANIFEST_FAILURE'
export const GET_MANIFEST_REQUEST = 'GET_MANIFEST_REQUEST'

export function getManifestRequest () : Action {
  return {
    type: GET_MANIFEST_REQUEST
  }
}

export function getManifestFailure (error: APIError) : Action {
  return getErrorAction(
    GET_MANIFEST_FAILURE,
    error
  )
}

export function getManifestSuccess (response: Object) : Action {
  return {
    type: GET_MANIFEST_SUCCESS,
    manifest: response.manifest
  }
}

export function fetchManifest () : Function {
  return (dispatch, getState) => {
    const state = getState()
    const url = `${getApiBaseUrl()}/api/manifest`
    return (basicGet(state, dispatch, url, getManifestRequest, getManifestSuccess, getManifestFailure))
  }
}
